import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import rawBankTransactionsApi from '@/features/dashboard/rawBankTransactions/api/rawBankTransactionsApi.ts';
import { RawTransactionDto } from '@/features/dashboard/rawBankTransactions/types/RawTransactionDto.ts';
import { MatchToBookingRequestDto } from '@/features/dashboard/rawBankTransactions/types/BankTransactionRequests.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';
import { getMatchToBookingErrorMessage } from '@/features/dashboard/rawBankTransactions/api/rawBankTransactionErrors.ts';

const useMatchToBooking = () => {
  const queryClient = useQueryClient();

  return useMutation<
    RawTransactionDto,
    Error,
    { id: string; request: MatchToBookingRequestDto }
  >({
    mutationFn: ({ id, request }) =>
      rawBankTransactionsApi.matchToBooking(id, request),
    onSuccess: () => {
      toast.success('Transakcja dopasowana do rezerwacji');
      invalidateFinanceRelatedQueries(queryClient);
    },
    onError: (error: Error) => {
      toast.error('Nie udało się dopasować transakcji', {
        description: getMatchToBookingErrorMessage(error) ?? error.message,
      });
    },
  });
};

export default useMatchToBooking;
